import React, { useState } from 'react'
import { useWebsocketContext } from './WebsocketProvider'
import { TextField, Button } from '@mui/material'

const SendBroadcast = () => {
  const { broadcastAnnouncement } = useWebsocketContext()
  const [message, setMessage] = useState('')

  const handleSend = () => {
    console.log('[handleSend] sending message', message)
    broadcastAnnouncement(message)
    setMessage('')
  }

  return (
    <>
      <TextField label="Custom Message" value={message} onChange={e => setMessage(e.target.value)} fullWidth />
      <Button onClick={handleSend}>Broadcast Grobotic Message</Button>
    </>
  )
}

export default SendBroadcast

// import React from 'react'
// import { useWebsocketContext } from './WebsocketProvider'
// import { TextField, Button } from '@mui/material'
// const SendBroadcast = () => {
//   const { customMessage, setCustomMessage, broadcastAnnouncement } = useWebsocketContext()
//   return (
//     <>
//       <TextField
//         label="Custom Message"
//         variant="outlined"
//         value={customMessage}
//         onChange={e => setCustomMessage(e.target.value)}
//         fullWidth
//         margin="normal"
//       />
//       <Button onClick={broadcastAnnouncement} variant="contained" color="primary">
//         Broadcast Grobotic Message
//       </Button>
//     </>
//   )
// }

// export default SendBroadcast

/*

ok now i am trying to finalize a few things.  Inside my organizations details page when clicking into an organization, you can edit most things but I need to add the functionality of being able to change the contacts attached to an organization.

*/
